/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { catchError } from 'rxjs/operators'
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import 'rxjs/add/observable/forkJoin';
import { CacheService } from '../global/ng2-cache/services/cache.service';
import { SocketService } from '../services/socket.service';

@Injectable()
export class SessionService {
  private observable: Observable<any>;
  private cachedSession: any = null;

  constructor(
    private http: HttpClient,
    private cacheService: CacheService,
    private socketService: SocketService) { }

  initSession(): Promise<any> {
    return this.getSession().toPromise();
  }

  getSession(forceRefresh?: boolean): Observable<any> {
    this.cachedSession = this.cacheService.get('session');
    if (this.cachedSession && !forceRefresh) {
      // if `cachedSession` is available just return it as `Observable`
      this.socketService.joinChannel(this.cachedSession.account_id);
      return Observable.of(this.cachedSession);
    } else if (this.observable) {
      // if `this.observable` is set then the request is in progress
      // return the `Observable` for the ongoing request
      return this.observable;
    } else {
      // store the `Observable` for subsequent subscribers
      this.observable = this.http.get(`/api/v1/session`)
      .map((response: any) => {

        // we can removed the reference to "observable" once the data is available
        this.observable = null;
        this.cacheService.set('session', response);
        this.socketService.joinChannel(response.account_id);
        return response;
        })
        .pipe(catchError(err => {
          this.observable = null;
          return new ErrorObservable(err);
        }))
        .share();

      return this.observable;
    }
  }

  saveSession(session): Observable<any> {
    return this.http.post(
        `/api/v1/session`,
        session
      )
      .map((response: any) => {
        this.cacheService.set('session', session);
        return response;
      });
  }

  changeAccount(accountId, accountName): Observable<any> {
    let model = {
      account_id: accountId,
      account_name: accountName
    };

    return this.http.post(
      `/api/v1/session/switch`,
      model
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/session2.service.ts